import type { PropsWithChildren, FC, CSSProperties } from 'react';
import classNames from 'classnames';

import Error from 'app/components/Error';
import TeamAvatar from 'app/components/TeamAvatar';

import style from './style.module.scss';

interface Props extends PropsWithChildren {
  title?: string;
  opponentsLogo?: [OpponentBase | undefined, OpponentBase | undefined];
  hasData?: boolean;
  errorType?: BlockErrorType;
  contentClassName?: string;
  skipRenderIfNoData?: boolean;
  noFrame?: boolean;
  style?: CSSProperties;
}

const BlockGradTemplate: FC<Props> = ({
  title,
  opponentsLogo,
  hasData,
  errorType = 'no-data',
  children,
  contentClassName,
  skipRenderIfNoData = false,
  noFrame = false,
  style: inlineStyle
}) => {
  if (skipRenderIfNoData && !hasData) {
    return null;
  }

  const hasHeader = !!title || (opponentsLogo && opponentsLogo?.filter(Boolean).length > 0);

  return (
    <section className={classNames({ [style.blockTemplate]: !noFrame })} style={inlineStyle}>
      {hasHeader && (
        <header className={style.blockTemplateHeader}>
          {opponentsLogo && (
            <>
              {opponentsLogo.at(0) ? (
                <TeamAvatar team={opponentsLogo.at(0)} className={style.teamAvatar} />
              ) : (
                <span className={style.teamAvatar} />
              )}
            </>
          )}
          {title && <h2 className={style.blockTemplateTitle}>{title}</h2>}
          {opponentsLogo && (
            <>
              {opponentsLogo.at(1) ? (
                <TeamAvatar team={opponentsLogo.at(1)} className={style.teamAvatar} />
              ) : (
                <span className={style.teamAvatar} />
              )}
            </>
          )}
        </header>
      )}
      <div className={contentClassName}>
        {hasData ? (
          children
        ) : (
          <Error type={errorType} floatingRectanglesClassName={style.floatingRectangles} />
        )}
      </div>
    </section>
  );
};

BlockGradTemplate.displayName = 'BlockGradTemplate';

export default BlockGradTemplate;
